const actionTypes = require('constants/actionTypes');
const { Promise } = require('es6-promise');
const { APIPut } = require('utilities/APIRequestHelper');
const signaturePatternActions = require('actions/signaturePattern');

const resetModifyEcommerceKey = () => ({
    type: actionTypes.ECOMMERCE_MODIFY_KEY_RESET
});

const confirmModifyEcommerceKey = () => ({
    type: actionTypes.ECOMMERCE_MODIFY_KEY_CONFIRM_STEP,
});

const requestModifyEcommerceKey = () => ({
    type: actionTypes.FETCH_ECOMMERCE_MODIFY_KEY_REQUEST
});

const setEcommerceKeyField = (challenge) => ({
    type: actionTypes.SET_ECOMMERCE_KEY,
    payload: challenge
});

const modifyEcommerceKeySuccess = () => ({
    type: actionTypes.FETCH_ECOMMERCE_MODIFY_KEY_SUCCESS,
});

const modifyEcommerceKeyFailure = () => ({
    type: actionTypes.FETCH_ECOMMERCE_MODIFY_KEY_FAILURE,
});

const sendNewEcommerceKey = (challenge) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {

       const requestData = {
            query: {
                dataToken,
                challenge
            }
        };

        dispatch(requestModifyEcommerceKey())
        APIPut({
            dispatch,
            endpoint: 'ecommerceKeyRequest',
            params: requestData
        })
        
        .then(() => dispatch(modifyEcommerceKeySuccess()))
        .catch(() => dispatch(modifyEcommerceKeyFailure()))
    }

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    resetModifyEcommerceKey,
    sendNewEcommerceKey,
    confirmModifyEcommerceKey,
    setEcommerceKeyField
}